import "./polyfills";
import ResponsiveImages from "./responsive-images";
import Router from "./router";
import Nav from "../../views/components/nav/nav";
import View from "./view";
import radio from "./radio";

class App extends View {
  el = "#app";

  ui = {
    links: `a[href]`,
    wrapper: "#page-wrapper",
    accordionToggle: ".js-accordion-toggle",
  };

  events = {
    "click @ui.links": "handleLinkClick",
    "click @ui.accordionToggle": "handleToggleClick",
  };

  constructor() {
    super();
    this.responsiveFactory = new ResponsiveImages();
  }

  init() {
    this.router = new Router(this);

    // Init Nav
    new Nav().render();
  }

  handleLinkClick(e) {
    const target = e.currentTarget || e.target;
    if (!target) return;

    const href = target.href;

    if (href.includes("#open-form")) {
      e.preventDefault();
      e.stopPropagation();
      radio.trigger("contact-form:open");
    } else if (
      href == window.location.href ||
      !href.startsWith(window.location.origin) ||
      target.target.startsWith("_blan") ||
      target.classList.contains("no-route")
    ) {
    } else {
      //e.preventDefault();
      //this.router.fetchPage(href);
    }
  }

  handleToggleClick(e) {
    e.currentTarget.parentElement.classList.toggle("is-active");
  }
}

window.app = new App();
window.app.render();
